/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.23.0
 */

import { ESubscriberIdActions } from '../../../types';
import { IProductItem } from '../types';

export const btnConnection = (product: IProductItem) => product.actions[ESubscriberIdActions.productDisconnect];


